import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { CheckoutCompleteNavExtras } from '../../models';
import { inject } from '@angular/core';

export abstract class NgxAimRentalCompleteClass {
  location = inject(Location);
  router = inject(Router);

  orderId = '';

  constructor() {
    const state = this.location.getState() as CheckoutCompleteNavExtras;
    if (state?.orderId) {
      this.orderId = state.orderId;
    } else {
      this.router.navigateByUrl('/');
    }
  }
}